"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get GetOrgChartResponse () {
        return GetOrgChartResponse;
    },
    get OrgChartEmployee () {
        return OrgChartEmployee;
    },
    get OrgChartEmployeeFieldValue () {
        return OrgChartEmployeeFieldValue;
    },
    get OrgChartField () {
        return OrgChartField;
    }
});
const _zod = require("zod");
const _utilsisomorphic = require("@performyard/utils-isomorphic");
const OrgChartFieldId = _zod.z.union([
    _utilsisomorphic.transformObjectId,
    _zod.z.literal("name")
]);
const OrgChartField = _zod.z.object({
    id: OrgChartFieldId,
    name: _zod.z.string()
});
const OrgChartEmployeeFieldValue = _zod.z.object({
    id: OrgChartFieldId,
    name: _zod.z.string(),
    value: _zod.z.string()
});
const OrgChartEmployee = _zod.z.object({
    id: _utilsisomorphic.transformObjectId,
    name: _zod.z.string(),
    managerId: _utilsisomorphic.transformObjectId.nullable(),
    department: _zod.z.string().nullable(),
    fields: _zod.z.array(OrgChartEmployeeFieldValue)
});
const GetOrgChartResponse = _zod.z.object({
    company: _zod.z.object({
        id: _utilsisomorphic.transformObjectId,
        name: _zod.z.string()
    }),
    fields: _zod.z.array(OrgChartField),
    employees: _zod.z.array(OrgChartEmployee)
});
